export const LOCALE = {
    CostaRica:'CR',
    Colombia:'CO',
    Panama:'PA',
    DominicanRepublic:'RD'
};